import { atom } from 'jotai';
import { Project_Base } from '~/common/typescript/models/Project';
import { User_Base } from '~/common/typescript/models/User';
import { AC_TLGeo_Role } from '~/common/typescript/services/access_control/AC_Tlgeo';

/**
 * Store logged user information
 */
export const userInformationAtom = atom<User_Base | undefined>(undefined);

export const userACRoles = atom<AC_TLGeo_Role[]>([]);
